export default __webpack_public_path__ + "static/media/horseshoe.46353c8e.png";